import { render, staticRenderFns } from "./ParametersWrapperNode.vue?vue&type=template&id=38966c0c&"
import script from "./ParametersWrapperNode.vue?vue&type=script&lang=js&"
export * from "./ParametersWrapperNode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports